import { render, staticRenderFns } from "./ApproveAdjustment.vue?vue&type=template&id=121b8ac9&scoped=true&"
import script from "./ApproveAdjustment.vue?vue&type=script&lang=js&"
export * from "./ApproveAdjustment.vue?vue&type=script&lang=js&"
import style0 from "./InputAdjustment.scss?vue&type=style&index=0&id=121b8ac9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121b8ac9",
  null
  
)

export default component.exports